module.exports = __webpack_public_path__ + "img/app-scan-black.2865ab7a.png";